module.exports = __webpack_public_path__ + "static/media/arrow-left.80981e75.svg";